import XLSX from 'xlsx'

export default {
  data() {
    return {
      //题目的偏移量
      topicOffset: 0,
      //题目请求的条数
      topicLength: 15,
      //查询时候的题目名字
      topicSearchName: '',
      //题目的总条数
      topicTotal: 0,
      //添加题目的弹窗
      dialogTableVisible: false,
      //修改题目的弹窗
      dialogTableVisiblexiugai: false,
      //课后习题的资源
      afterClass: [],
      //添加题目的标题
      topicText: "",
      //添加题目的data
      topicData: "",
      //修改题目时候的标题
      updateTopciText: "",
      //修改题目时候需要的data，即内容
      updateTopciData: "",
      //修改题目时候需要的id
      updateTopicId: "",
      // 下载模板
      download: this.baseUrl + 'excel/batch_template.xlsx'
    }
  },
  methods: {
    //确定添加一个课后习题
    confirmAddTopic() {
      //校验添加题目是否为空
      if (this.topicText == "" || this.topicData == "") {
        this.$message({
          message: "题目标题和内容均不能为空!",
          type: "error"
        })
        return false;
      }
      //发送给后台的数据
      let data = {
        token: this.$store.state.authority_management,
        name: this.topicText,
        data: this.topicData,
        type: "7",
        shop_id: this.$store.state.store.id
      };
      //发送请求创建
      this.$post("resources/shop_create", data).then(res => {
        if (res.data.status == "success") {
          this.$message({
            message: "题目创建成功!",
            type: "success"
          })
          //清空输入框
          this.topicText = "";
          this.topicData = "";
          //关闭弹窗
          this.dialogTableVisible = false;
          //刷新数据
          this.getTopics();
        } else {
          this.$message({
            message: "题目创建失败!",
            type: "error"
          })
        }
      })
    },
    //弹窗编辑弹窗
    updateTopic(obj) {
      //弹出弹窗
      this.dialogTableVisiblexiugai = true;
      //获取id
      this.updateTopicId = obj.id;
      //获取试题题目
      this.updateTopciText = obj.name;
      //获取简单题内容
      this.updateTopciData = obj.data;
    },
    //确定修改一个课后习题
    confirmUpdateTopic() {
      //校验添加题目是否为空
      if (this.updateTopciText == "" || this.updateTopciData == "") {
        this.$message({
          message: "题目标题和内容均不能为空!",
          type: "error"
        })
        return false;
      }
      //发送给后台的数据
      let data = {
        id: this.updateTopicId,
        token: this.$store.state.authority_management,
        name: this.updateTopciText,
        data: this.updateTopciData,
        type: "7",
      };
      //发送请求创建
      this.$post("resources/shop_edit", data).then(res => {
        if (res.data.status == "success") {
          this.$message({
            message: "修改成功!",
            type: "success"
          })
          //清空输入框和id
          this.updateTopicId = "";
          this.updateTopciText = "";
          this.updateTopciData = "";
          //关闭弹窗
          this.dialogTableVisiblexiugai = false;
          //刷新数据
          this.getTopics();
        } else {
          this.$message({
            message: "修改失败!",
            type: "error"
          })
        }
      })

    },
    //删除简答题目资源
    deleteTpoic(id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //删除发送给后台的数据
        let data = {
          token: this.$store.state.authority_management,
          id: id
        };
        //删除发起的请求
        this.$post("resources/delete", data).then(res => {
          if (res.data.status == 'success') {
            this.$message({
              message: "删除成功!",
              type: "success"
            })
            //删除成功后刷新数据
            this.getTopics();
          } else {
            this.$message({
              message: "删除失败!",
              type: "error"
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //获取课后习题资源
    getTopics() {
      //发送的请求的数据
      let data = {
        offset: this.topicOffset,
        length: this.topicLength,
        name: this.topicSearchName,
        type: '7',
        token: this.$store.state.authority_management
      }
      //发送查询的请求
      this.$post("resources/shop_search", data).then(res => {
        // // console.log(res.data);
        this.topicTotal = res.data.result.total;
        this.afterClass = res.data.result.data;
    	
      })
    },
	//搜索
	search() {
	  //发送的请求的数据
	  let data = {
	    offset: 0,
	    length: this.topicLength,
	    name: this.topicSearchName,
	    type: '7',
	    token: this.$store.state.authority_management
	  }
	  //发送查询的请求
	  this.$post("resources/shop_search", data).then(res => {
	    // // console.log(res.data);
	    this.topicTotal = res.data.result.total;
	    this.afterClass = res.data.result.data;
		this.currentPage = 1
	  })
	},
    //当请求条数发生变化时候
    handleSizeChange(val) {
      //改变请求条数
      this.topicLength = val;
      //重新刷新数据
      this.getTopics();
    },
    //当页数发生改变时候触发
    handleCurrentChange(val) {
      //改变偏移量
      this.topicOffset = (val - 1) * this.topicLength;
      //重新刷新数据
      this.getTopics();
    },

    // 批量上传简答题
    upload(file, fileList) {
      let files = { 0: file.raw }
      this.readExcel(files);
    },

    // 读取表格
    readExcel(files) {
      var that = this;
      if (files.length <= 0) {//如果没有文件名
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
        this.$Message.error('上传格式不正确，请上传xls或者xlsx格式');
        return false;
      }

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表

          const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容
          this.insert(ws)

          // that.peopleArr = [];//清空接收数据
          // if(that.peopleArr.length == 1 && that.peopleArr[0].roleName == "" && that.peopleArr[0].enLine == ""){
          //     that.peopleArr = [];
          // }
          //重写数据
          // try {

          // } catch (err) {
          //   console.log(err)
          // }

          this.$refs.upload.value = '';

        } catch (e) {
          return false;
        }
      }
      fileReader.readAsBinaryString(files[0]);
    },

    // 发送请求插入简答题数据
    insert(list) {
      list.map(item => {
        this.$post('resources/shop_create', {
          token: this.$store.state.authority_management,
          shop_id: this.$store.state.store.id,
          name: item.title,
          data: item.content,
          type: "7"
        }).then(res => {
          this.$message({
            message: "新增简答题成功!",
            type: "success"
          })
        })
      })
    }
  },
  created() {
    this.getTopics();
  }
}